import { getMessage } from 'common/helpers/miscHelper';

const WelcomeMessage = (props) => {
  const { customer, settings } = props;
  let message = getMessage('Profile Welcome Message', settings);
  if (customer.firstName) {
    message = message.replace(/{{customer.firstName}}/g, customer.firstName);
  } else {
    message = message.replace(/{{customer.firstName}}/g, '');
  }
  return (
    <>
      <div
        className="c7-account__dashboard__message"
        dangerouslySetInnerHTML={{
          __html: message
        }}
      />
    </>
  );
};

export default WelcomeMessage;
